import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import Image from 'next/image';
import { Disclosure } from '@headlessui/react';
import { MenuIcon, XIcon } from '@heroicons/react/outline';
import Link from 'next/link';
import speakerNotesBlack from 'public/speaker_notes_black_48dp.svg';
import { hasCookie } from 'lib/util';
import { NavBarMenu, NavBarMenuMobile } from 'components/nav-bar-menu';

const HomeLink = ({ children }: { children: ReactNode }) => {
  const [link, setLink] = useState('/');

  useEffect(() => {
    if (hasCookie('transcribekit-auth')) setLink('/transcripts');
  }, []);

  return (
    <Link href={link}>
      <a>{children}</a>
    </Link>
  );
};

export default function NavBarNoAuth(): ReactElement {
  return (
    <Disclosure as="nav">
      {({ open }) => (
        <>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 border-b">
            <div className="flex items-center justify-between h-16">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <HomeLink>
                    <span className="sr-only">Home</span>
                    <Image
                      className="h-8 w-auto sm:h-10"
                      src={speakerNotesBlack}
                      alt=""
                      layout="fixed"
                      quality={100}
                      priority
                    />
                  </HomeLink>
                </div>
                <div className="ml-4 text-2xl font-bold">
                  <HomeLink>TranscribeKit</HomeLink>
                </div>
                <div className="hidden md:block">
                  <NavBarMenu />
                </div>
              </div>
              <div className="-mr-2 flex md:hidden">
                {/* Mobile menu button */}
                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="md:hidden border-b">
            <NavBarMenuMobile />
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
